import React from "react";
import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLang = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  // ✅ Simplified current language check
  const currentLang = i18n.language;

  return (
    <div
      className="lang-switcher"
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        display: "flex",
        gap: "10px",
        background: "rgba(255, 255, 255, 0.85)",
        borderRadius: "8px",
        padding: "6px 10px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
        fontSize: "14px",
        zIndex: 1000, // ✅ Added to ensure it stays on top
      }}
    >
      <button
        onClick={() => changeLang("en")}
        style={{
          border: "none",
          background: currentLang === "en" ? "#007bff" : "transparent",
          color: currentLang === "en" ? "white" : "#333",
          borderRadius: "6px",
          padding: "4px 8px",
          cursor: "pointer",
          transition: "all 0.2s", // ✅ Added smooth transition
        }}
      >
        🇺🇸 English
      </button>

      <button
        onClick={() => changeLang("vi")}
        style={{
          border: "none",
          background: currentLang === "vi" ? "#007bff" : "transparent",
          color: currentLang === "vi" ? "white" : "#333",
          borderRadius: "6px",
          padding: "4px 8px",
          cursor: "pointer",
          transition: "all 0.2s", // ✅ Added smooth transition
        }}
      >
        🇻🇳 Tiếng Việt
      </button>
    </div>
  );
}